import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrowUpRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6 4.5H11.5M11.5 4.5V10M11.5 4.5L4.5 11.5" stroke={color} />
    </svg>
  ),
)

ArrowUpRight.displayName = 'ArrowUpRight'

ArrowUpRight.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ArrowUpRight
